module.exports = parcelRequire.resolve("eILih");